// The recording that has not reached storage yet, kept on the device (TX-US-0028).
//
// A BD who talks for ten minutes and loses it does not talk for ten minutes again. So a take is
// written here the moment it exists and removed only once the API has confirmed it in storage:
// a dropped connection, a closed tab or a phone that slept leaves it here, and the hub offers it
// again the next time it is opened.
//
// IndexedDB because it holds a Blob as it is; one take per person, keyed on their email, because a
// session has one recording and a phone may be shared.

const DATABASE = 'trex-hub';
const STORE = 'unsent-recordings';

function open() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE, { keyPath: 'email' });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function run(mode, work) {
  const database = await open();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE, mode);
      const request = work(transaction.objectStore(STORE));
      transaction.oncomplete = () => resolve(request.result);
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    database.close();
  }
}

// What is kept: the take, and when it was made - which is how the BD recognises it later.
export const unsentEntry = (email, take, recordedAt = new Date()) => ({
  email,
  blob: take.blob,
  contentType: take.contentType,
  durationSeconds: take.durationSeconds,
  recordedAt: recordedAt.toISOString(),
});

// The take as the uploader expects it, back out of an entry.
export const takeOf = (entry) => ({
  blob: entry.blob,
  contentType: entry.contentType,
  durationSeconds: entry.durationSeconds,
});

export const holdUnsent = (email, take) => run('readwrite', (store) => store.put(unsentEntry(email, take)));

export const unsentFor = async (email) => (await run('readonly', (store) => store.get(email))) ?? null;

export const releaseUnsent = (email) => run('readwrite', (store) => store.delete(email));
